<template>
  <v-container class="pb-0">
    <div class="d-flex align-center">
      <span class="pr-5 text-007C92 w-500 font-18">บันทึกสุขภาพ</span>
      <v-divider></v-divider>
    </div>
    <v-form ref="create_info">
      <v-row>
        <v-col cols="12" lg="5" class="px-0">
          <v-row class="px-0 mx-0">
            <v-col cols="12" lg="5" align-self="center">
              <v-select
                solo
                dense
                hide-details="auto"
                v-model="selectYear"
                :items="itemYear"
                item-value="value"
                item-text="text"
                @input="filter"
              >
                <template v-slot:prepend> ปี </template>
              </v-select>
            </v-col>
            <v-col cols="12" lg="5" align-self="center">
              <v-select
                solo
                dense
                hide-details="auto"
                item-text="text"
                v-model="selectMonth"
                item-value="value"
                :items="months"
                @input="filter"
              >
                <template v-slot:prepend> เดือน </template>
              </v-select>
            </v-col>
            <v-col
              cols="12"
              lg="2"
              align-self="center"
              class="d-flex justify-end"
            >
              <span class="text-007C92 font-16 w-500">
                {{ getHealth.tatals }} <span class="font-16 w-300">ครั้ง</span>
              </span>
            </v-col>
            <v-col cols="12" lg="12" v-if="getHealth.data.length !== 0" style="overflow-x: auto;max-height: 1000px;">
              <v-list dense>
                <v-list-item-group v-model="selectedItem">
                  <v-list-item
                    v-for="(item, index) in getHealth.data"
                    :key="index"
                    class="my-2"
                    :value="index"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        <div class="d-flex flex-column">
                          <span class="w-500 font-18">{{
                            convertDate(item, "timeslotdentist")
                          }}</span>
                          <span class="w-300 font-16 mt-2">
                            {{ convertTimeStart(item, "timeslotdentist") }} -
                            {{ convertTimeEnd(item, "timeslotdentist") }} น.
                          </span>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="7" :style="myStyle">
          <v-row
            class="pa-0 ma-0"
            v-if="getHealth.tatals !== 0 && selectedItem !== undefined"
          >
            <v-col cols="12">
              <span class="w-500 font-24 text-007C92">{{
                convertDate(getHealth.data[selectedItem], "timeslotdentist")
              }}</span>
              <span class="w-300 font-16 text-09425A ml-3"
                >{{
                  convertTimeStart(
                    getHealth.data[selectedItem],
                    "timeslotdentist"
                  )
                }}
                -
                {{
                  convertTimeEnd(
                    getHealth.data[selectedItem],
                    "timeslotdentist"
                  )
                }}
                น.</span
              >
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
              <span class="w-500 font-18 text-navy-50">ข้อมูลเบื้องต้น</span>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41"> ส่วนสูง (cm.) </span>
                <v-text-field
                  :readonly="view"
                  v-model="getHealth.data[selectedItem].height"
                  solo
                  hide-details="auto"
                  dense
                  placeholder="กรอกส่วนสูง (cm.)"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41"> PR (bpm.) </span>
                <v-text-field
                  :readonly="view"
                  solo
                  v-model="getHealth.data[selectedItem].pulseRate"
                  hide-details="auto"
                  dense
                  placeholder="อัตราการเต้นหัวใจ"
                ></v-text-field>
                <div v-if="info_pr">
                  <p
                    class="font-12 mb-0"
                    v-for="(pr, index) in info_pr"
                    :key="`pr-${index}`"
                  >
                    {{ pr }}
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41"> รอบเอว (cm.) </span>
                <v-text-field
                  :readonly="view"
                  v-model="getHealth.data[selectedItem].girth"
                  solo
                  hide-details="auto"
                  dense
                  placeholder="กรอกรอบเอว (cm.)"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41"> น้ำหนัก (kgs.) </span>
                <v-text-field
                  :readonly="view"
                  solo
                  v-model="getHealth.data[selectedItem].weight"
                  hide-details="auto"
                  dense
                  placeholder="กรอกน้ำหนัก (kgs.) "
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41">
                  BP
                  <span class="w-300 font-12 text-313B41"
                    >ตัวอย่าง (120/80)
                  </span>
                </span>
                <v-text-field
                  :readonly="view"
                  solo
                  hide-details="auto"
                  dense
                  v-model="getHealth.data[selectedItem].bloodPressure"
                  placeholder="ความดันโลหิต"
                ></v-text-field>
                <div v-if="info_bp">
                  <p
                    v-for="(bp, index) in info_bp"
                    :class="`font-12 mb-0 ${bp.c}`"
                    :key="`bp-${index}`"
                  >
                    {{ bp.t }}
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41"> การตั้งครรภ์ </span>
                <v-select
                  :readonly="view"
                  solo
                  v-model="getHealth.data[selectedItem].pregnancy"
                  hide-details="auto"
                  :items="itemsPregnancy"
                  item-value="value"
                  item-text="text"
                  dense
                ></v-select>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41"> BMI </span>
                <v-text-field
                  solo
                  :value="convertBMI()"
                  hide-details="auto"
                  dense
                  disabled
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41"> RR (/min.) </span>
                <v-text-field
                  :readonly="view"
                  v-model="getHealth.data[selectedItem].respiratoryRate"
                  solo
                  hide-details="auto"
                  dense
                  placeholder="อัตราการหายใจ"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41"> ดื่มแอลกอฮอล์ </span>
                <v-select
                  :readonly="view"
                  solo
                  v-model="getHealth.data[selectedItem].alcohol"
                  hide-details="auto"
                  :items="itemsAlcohol"
                  item-value="value"
                  item-text="text"
                  dense
                ></v-select>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41">
                  อุณหภูมิ (<v-icon size="18" color="#313B41"
                    >mdi-temperature-celsius</v-icon
                  >)
                </span>
                <v-text-field
                  :readonly="view"
                  solo
                  v-model="getHealth.data[selectedItem].temperature"
                  hide-details="auto"
                  dense
                  placeholder="กรอกอุณหภูมิ"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41"> DTX (mg/dl.) </span>
                <v-text-field
                  solo
                  :readonly="view"
                  hide-details="auto"
                  v-model="getHealth.data[selectedItem].dextrostix"
                  dense
                  placeholder="ระดับน้ำตาลในเลือด"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41"> สูบบุหรี่ </span>
                <v-select
                  solo
                  :readonly="view"
                  hide-details="auto"
                  v-model="getHealth.data[selectedItem].smoke"
                  :items="itemsSmoke"
                  item-value="value"
                  item-text="text"
                  dense
                ></v-select>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-18 text-313B41">
                  ค่าออกซิเจนในเลือด
                </span>
                <v-text-field
                  solo
                  v-model="getHealth.data[selectedItem].SpO2"
                  :readonly="view"
                  hide-details="auto"
                  dense
                  placeholder="ค่าออกซิเจนในเลือด"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex flex-column">
              <div class="d-flex align-center">
                <span class="pr-5 text-007C92 w-500 font-18">
                  ฐานข้อมูลโรงพยาบาล
                </span>
                <v-divider></v-divider>
              </div>
              <div class="d-flex flex-column mt-3">
                <span class="w-300 font-18 text-313B41"> โรคประจำตัว </span>
                <v-text-field
                  solo
                  v-model="getHealth.data[selectedItem].congenital_disease"
                  :readonly="view"
                  hide-details="auto"
                  dense
                  placeholder="กรอกโรคประจำตัว"
                ></v-text-field>
              </div>
              <div class="d-flex flex-column mt-3">
                <span class="w-300 font-18 text-313B41"> ยาที่ใช้ประจำ </span>
                <v-text-field
                  solo
                  :readonly="view"
                  v-model="getHealth.data[selectedItem].medication"
                  hide-details="auto"
                  dense
                  placeholder="กรอกยาที่ใช้ประจำ"
                ></v-text-field>
              </div>
              <div class="d-flex flex-column mt-3">
                <span class="w-300 font-18 text-313B41"> ยาที่แพ้ </span>
                <v-text-field
                  solo
                  v-model="getHealth.data[selectedItem].allergyDrug"
                  :readonly="view"
                  hide-details="auto"
                  dense
                  placeholder="กรอกยาที่แพ้"
                ></v-text-field>
              </div>
              <div class="d-flex flex-column mt-3">
                <span class="w-300 font-18 text-313B41"> อาการปัจจุบัน </span>
                <v-text-field
                  solo
                  :readonly="view"
                  v-model="getHealth.data[selectedItem].currentSymptoms"
                  hide-details="auto"
                  dense
                  placeholder="กรอกอาการปัจจุบัน "
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex flex-column">
              <div
                style="border-top: 1px solid #09425a; background: #09425a"
                class="my-5"
              />
              <div class="d-flex justify-end pt-3" v-if="!view">
                <v-btn width="30%" color="#1CA7B4" outlined @click="closePage"
                  >ยกเลิก</v-btn
                >
                <div class="px-2"></div>
                <v-btn width="30%" dark color="#1CA7B4" @click="save"
                  >บันทึก</v-btn
                >
              </div>
              <v-btn
                v-else
                width="30%"
                color="#1CA7B4"
                outlined
                @click="closePage"
                >ยกเลิก</v-btn
              >
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" class="noitems d-flex justify-center align-center text-center">
              <h2>ไม่มีบันทึกสุขภาพ</h2>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      rule_BP: [
        (v) => {
          if (v === null) return true;
          return true;
        },
      ],
      rule_PR: [
        (v) => {
          if (v === null) return true;
        },
      ],
      selectYear: 2021,
      selectMonth: 0,
      months: [
        { value: 0, text: "ทั้งหมด" },
        { value: "01", text: "มกราคม" },
        { value: "02", text: "กุมภาพันธ์" },
        { value: "03", text: "มีนาคม" },
        { value: "04", text: "เมษายน" },
        { value: "05", text: "พฤษภาคม" },
        { value: "06", text: "มิถุนายน" },
        { value: "07", text: "กรกฎาคม" },
        { value: "08", text: "สิงหาคม" },
        { value: "09", text: "กันยายน" },
        { value: 10, text: "ตุลาคม" },
        { value: 11, text: "พฤศจิกายน" },
        { value: 12, text: "ธันวาคม" },
      ],
      selectedItem: 0,
      items: [
        { date: "10 เมษายน 2564", time: "09:00 - 09:30 น.", value: "text-1" },
        { date: "10 เมษายน 2564", time: "09:00 - 09:30 น.", value: "text-2" },
        { date: "10 เมษายน 2564", time: "09:00 - 09:30 น.", value: "text-3" },
      ],
      itemsICD10: 1,
      itemsICD9: 1,
      selectHealth: {},
      itemsPregnancy: [
        { value: 0, text: "ไม่ได้ตั้งครรภ์" },
        { value: 1, text: "ตั้งครรภ์" },
      ],
      itemsAlcohol: [
        { value: 0, text: "ไม่ได้ดื่มแอลกอฮอล์" },
        { value: 1, text: "ดื่มแอลกอฮอล์" },
      ],
      itemsSmoke: [
        { value: 0, text: "ไม่ได้สูบบุหรี่" },
        { value: 1, text: "สูบบุหรี่" },
      ],
      windowWidth: window.innerWidth,
    };
  },
  props: {
    reset: { type: Boolean, default: true },
  },
  watch: {
    reset() {
      this.reset_data();
    },
  },
  mounted() {
    // this.displayTracking()
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    // eventBus.$off('add_user_get_data')
    this.$store.dispatch("windowWidthAction", this.windowWidth);
  },
  computed: {
    ...mapGetters({
      getHealth: "getHealthInfoGetter",
      view: "viewHistoryTalkingGetter",
      currentPatient: "currentPatientGetter",
      // ...
    }),
    myStyle() {
      const { windowWidth } = this;
      if (windowWidth < 1264) return "border-top:1px solid #E5e5e5";
      return "border-left:1px solid #E5e5e5";
    },
    itemYear() {
      // console.log(moment().year());
      let y = [];
      y.push({ value: moment().year() - 1, text: moment().year() - 1 + 543 });
      y.push({ value: moment().year(), text: moment().year() + 543 });
      y.push({ value: moment().year() + 1, text: moment().year() + 1 + 543 });

      // console.log(y);
      return y;
    },
    info_bp() {
      const { getHealth = [] } = this;
      const { bloodPressure: v } = getHealth.data[this.selectedItem];
      let text = [];
      // console.log(v);
      // if (!this.$refs.create_info.validate()) return;
      // if (!this.$refs.create_info) return false;
      // if (this.$refs.create_info !== undefined) {
      //   if (!this.$refs.create_info.validate()) return false;
      // }
      if (v === null) return false;
      if (v === undefined) return false;
      if (v.split === undefined)
        return [{ t: "ความดันไม่ถูกต้อง", c: "red--text" }];
      if (v.split("/").length === 2) {
        if (!isNaN(parseInt(v.split("/")[0]))) {
          if (parseInt(v.split("/")[0]) > 140)
            text.push({ t: "*ความดันตัวบนสูงกว่าปกติ" });
          // return "*ความดันตัวบนสูงกว่าปกติ";

          if (parseInt(v.split("/")[0]) < 90)
            text.push({ t: "*ความดันตัวบนต่ำกว่าปกติ" });
          // return "*ความดันตัวบนต่ำกว่าปกติ";
        }
        if (!isNaN(parseInt(v.split("/")[1]))) {
          if (parseInt(v.split("/")[1]) > 90)
            text.push({ t: "*ความดันตัวล่างสูงกว่าปกติ" });
          // return "*ความดันตัวล่างสูงกว่าปกติ";
          if (parseInt(v.split("/")[1]) < 60)
            text.push({ t: "*ความดันตัวล่างต่ำกว่าปกติ" });
          // return "*ความดันตัวล่างต่ำกว่าปกติ";
        }
      } else return [{ t: "ความดันไม่ถูกต้อง", c: "red--text" }];

      return text.length === 0 ? false : text;
    },
    info_pr() {
      const { getHealth = [] } = this;
      const { pulseRate } = getHealth.data[this.selectedItem];
      // console.log(pulseRate);
      let text = [];
      // if (!this.$refs.create_info) return false;
      // if (this.$refs.create_info !== undefined) {
      //   if (!this.$refs.create_info.validate()) return false;
      // }
      if (pulseRate === null) return false;
      if (pulseRate < 60) text.push("*หัวใจเต้นช้ากว่าปกติ");
      if (pulseRate > 100) text.push("*หัวใจเต้นเร็วกว่าปกติ");
      if (pulseRate === "") return false;

      return text.length === 0 ? false : text;
    },
  },
  methods: {
    reset_data() {
      this.selectYear = moment().year();
      this.selectMonth = 0;
      this.selectedItem = 0;
    },
    closePage() {
      this.$emit("close");
      this.reset_data();
    },
    filter() {
      let dateMonth = this.selectMonth;
      if (this.selectMonth === 0) dateMonth = "";
      (this.selectedItem = 0),
        this.$store.dispatch("getHealthInfoAction", {
          patient_id: this.currentPatient,
          dentist_clinic_id: sessionStorage.dentist_clinic_id,
          year: this.selectYear,
          month: dateMonth,
        });
    },
    async save() {
      let find_bp = true;
      // console.log(this.info_bp);
      if (this.info_bp !== false) {
        this.info_bp.find((v) => {
          if (v.t === "ความดันไม่ถูกต้อง") return (find_bp = false);
          return (find_bp = true);
        });
      }
      if (!find_bp) {
        Swal.fire({
          type: "error",
          width: "auto",
          imageUrl: `${require("@/assets/icon/weather_R.png")}`,
          title: "รูปแบบความดันไม่ถูกต้อง ตัวอย่าง 120/80",
          imageWidth: 200,
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          position: "center",
          timer: 3000,
          backdrop: false,
        });
        return;
      }
      // if (!this.$refs.create_info.validate()) return;
      // console.log(this.getHealth.data[this.selectedItem]);
      // this.$emit("submit", this.selectHealth)
      const { data: { message = {} } = {} } = await this.axios.put(
        process.env.VUE_APP_BASE_URL_2 +
          `/health-info?id=${this.getHealth.data[this.selectedItem]._id}`,
        this.getHealth.data[this.selectedItem]
      );
      await this.$store.dispatch("actionLog", {
        action: "edit health info",
        action_by: sessionStorage.account_id,
        path: `/health-info`,
        params: {
          id: this.getHealth.data[this.selectedItem]._id
        },
        body: this.getHealth.data[this.selectedItem]
      });
      if (message === "success") {
        Swal.fire({
          type: "success",
          width: 366,
          imageUrl: `${require("@/assets/icon/Succes_G.png")}`,
          imageWidth: 100,
          imageHeight: 100,
          title: '<b class="alert">แก้ไขข้อมูลสำเร็จ</b>',
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          position: "center",
          timer: 3000,
          backdrop: false,
        });
      } else {
        Swal.fire({
          type: "error",
          width: "auto",
          imageUrl: `${require("@/assets/icon/weather_R.png")}`,
          imageWidth: 200,
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          position: "center",
          timer: 3000,
          backdrop: false,
        });
      }

      // console.log(message)
    },
    convertBMI() {
      const { getHealth = [] } = this;
      const { height, weight } = getHealth.data[this.selectedItem];
      const bmi = weight / ((height / 100) * (height / 100));
      return bmi.toFixed(2);
    },
    convertDate(date = "", key = "") {
      if (key === "") return "";
      const { date: date_timeslot } = date[key];

      var year1 = moment(this.date_timeslot).locale("th").format("YYYY")
      var year2 = (parseInt(year1) + 543).toString()

      return moment(date_timeslot).locale("th").format("DD MMMM "+ year2);
    },
    convertTimeStart(time = "", key = "") {
      if (key === "") return "";
      const { time_slot_start } = time[key];
      return time_slot_start;
    },
    convertTimeEnd(time = "", key = "") {
      if (key === "") return "";
      const { time_slot_end } = time[key];
      return time_slot_end;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
.left-content {
  width: 45%;
}
.right-content {
  width: 55%;
  // height: 100vh;
  margin-top: -12px;
  // margin-bottom: -12px;
  // border-left: 1px solid #babdbf;
}
.v-list-item-group .v-list-item--active {
  color: #fff;
  background: #0e535a;
}
.v-list-item {
  background: #e8f6f7;
  color: #000;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.noitems {
  height: 60vh;
}
</style>
